import { createContext, useContext } from 'react';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';

export const TargetLanguagesContext = createContext<DetailedSourceLanguageResponse[] | null>(null);

export const useTargetLanguagesContext = () => {
  const targetLanguages = useContext(TargetLanguagesContext);
  if (targetLanguages) return targetLanguages;
  throw new Error('TargetLanguagesContext must be used only inside TargetLanguagesProvider');
};
